var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-center my-1",
              attrs: { md: "4" },
            },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: { name: "check-button", switch: "", inline: "" },
                  model: {
                    value: _vm.displayCalendar,
                    callback: function ($$v) {
                      _vm.displayCalendar = $$v
                    },
                    expression: "displayCalendar",
                  },
                },
                [_vm._v(" Calendar ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.displayCalendar
        ? _c("div", [
            _c("div", { staticClass: "app-calendar overflow-hidden border" }, [
              _c(
                "div",
                { staticClass: "row no-gutters" },
                [
                  _c(
                    "div",
                    { staticClass: "col-sm-12" },
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "b-card-title",
                            { staticClass: "mb-1 text-center" },
                            [_vm._v("Legend")]
                          ),
                          _c(
                            "b-card-body",
                            {
                              staticClass:
                                "d-flex flex-wrap justify-content-center",
                            },
                            [
                              _c(
                                "b-badge",
                                {
                                  staticClass: "mb-2 mx-1",
                                  attrs: { variant: "primary" },
                                },
                                [_vm._v("Completed")]
                              ),
                              _c(
                                "b-badge",
                                {
                                  staticClass: "mb-2 mx-1",
                                  attrs: { variant: "info" },
                                },
                                [_vm._v("Not Started")]
                              ),
                              _c(
                                "b-badge",
                                {
                                  staticClass: "mb-2 mx-1",
                                  attrs: { variant: "secondary" },
                                },
                                [_vm._v("Started")]
                              ),
                              _c(
                                "b-badge",
                                {
                                  staticClass: "mb-2 mx-1",
                                  attrs: { variant: "danger" },
                                },
                                [_vm._v("Cancelled")]
                              ),
                              _c(
                                "b-badge",
                                {
                                  staticClass: "mb-2 mx-1",
                                  attrs: { variant: "warning" },
                                },
                                [_vm._v("Blocked")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col position-relative" }, [
                    _c(
                      "div",
                      {
                        staticClass: "card shadow-none border-0 mb-0 rounded-0",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card-body pb-0" },
                          [
                            _c("full-calendar", {
                              attrs: {
                                plugins: _vm.calendarPlugins,
                                events: _vm.fcEvents,
                                options: _vm.calendarOptions,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "b-sidebar",
                    {
                      ref: "sidebar",
                      attrs: {
                        id: "sidebar-right",
                        "bg-variant": "white",
                        right: "",
                        title: "View Job Card",
                        backdrop: "",
                        shadow: "",
                        visible: _vm.showSidebar,
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mt-1 w-100",
                          attrs: { size: "sm" },
                          on: {
                            click: function ($event) {
                              return _vm.goToPage(_vm.selectedItem)
                            },
                          },
                        },
                        [_vm._v(" View ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ])
        : _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "my-1",
                      attrs: { cols: "12", md: "2", sm: "2" },
                    },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredJobcards,
                          fields: _vm.fields,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection,
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "row-clicked": _vm.onRowClicked,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "head(name)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Job Card Name")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Job Card Name",
                                        size: "sm",
                                      },
                                      on: {
                                        input: function ($event) {
                                          _vm.currentPage = 1
                                        },
                                      },
                                      model: {
                                        value: _vm.filters.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "name", $$v)
                                        },
                                        expression: "filters.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(startDate)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Start Date")]),
                                    _c("DatePicker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        format: "YYYY-MM-DD",
                                        placeholder: "Select Start Date",
                                        size: "sm",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.currentPage = 1
                                        },
                                      },
                                      model: {
                                        value: _vm.filters.startDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "startDate",
                                            $$v
                                          )
                                        },
                                        expression: "filters.startDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(endDate)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("End Date")]),
                                    _c("DatePicker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        format: "YYYY-MM-DD",
                                        placeholder: "Select End Date",
                                        size: "sm",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.currentPage = 1
                                        },
                                      },
                                      model: {
                                        value: _vm.filters.endDate,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "endDate", $$v)
                                        },
                                        expression: "filters.endDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(status)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Status")]),
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.statusOptions,
                                        size: "sm",
                                      },
                                      on: {
                                        input: function ($event) {
                                          _vm.currentPage = 1
                                        },
                                      },
                                      model: {
                                        value: _vm.filters.status,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "status", $$v)
                                        },
                                        expression: "filters.status",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(priority)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Priority")]),
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.priorityOptions,
                                        size: "sm",
                                      },
                                      on: {
                                        input: function ($event) {
                                          _vm.currentPage = 1
                                        },
                                      },
                                      model: {
                                        value: _vm.filters.priority,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "priority", $$v)
                                        },
                                        expression: "filters.priority",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(status)",
                            fn: function (data) {
                              return [
                                data.item.status === 0
                                  ? _c(
                                      "b-badge",
                                      { attrs: { variant: "info" } },
                                      [_c("span", [_vm._v("Not Started")])]
                                    )
                                  : data.item.status === 1
                                  ? _c(
                                      "b-badge",
                                      { attrs: { variant: "secondary" } },
                                      [_c("span", [_vm._v("Started")])]
                                    )
                                  : data.item.status === 2
                                  ? _c(
                                      "b-badge",
                                      { attrs: { variant: "primary" } },
                                      [_c("span", [_vm._v("Completed")])]
                                    )
                                  : data.item.status === 3
                                  ? _c(
                                      "b-badge",
                                      { attrs: { variant: "danger" } },
                                      [_c("span", [_vm._v("Cancelled")])]
                                    )
                                  : data.item.status === 4
                                  ? _c(
                                      "b-badge",
                                      { attrs: { variant: "warning" } },
                                      [_c("span", [_vm._v("Blocked")])]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "cell(name)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-link",
                                  {
                                    attrs: {
                                      variant: "primary",
                                      to: _vm.getId(data.item.id),
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(data.item.name) + " ")]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return undefined
                            },
                          },
                          {
                            key: "cell(complete)",
                            fn: function (data) {
                              return [
                                data.item.status == 1 ||
                                data.item.status == 3 ||
                                data.item.status == 4
                                  ? _c("b-form-checkbox", {
                                      attrs: {
                                        checked: _vm.isChecked(data.item.id),
                                        disabled: _vm.isDisabled(
                                          data.item.status
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.checkboxChanged(
                                            data.item.id,
                                            $event
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }